import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {RequestInterceptor} from './interceptors/req-interceptor';
import { LangguardService } from './services/langguard/langguard.service';
import { environment } from 'src/environments/environment';

const routes: Routes = [
  {path: '', redirectTo: 'welcome', pathMatch: 'full' },
  {path: 'welcome', loadChildren: ()=>import('src/app/modules/welcome/welcome.module').then(m => m.WelcomeModule)},
  {path: 'user', loadChildren: ()=>import('src/app/modules/user/user.module').then(m => m.UserModule)},
  {path: 'checkout', loadChildren: ()=>import('src/app/modules/checkout/checkout.module').then(m => m.CheckoutModule)},
  {path: 'auth', loadChildren: ()=>import('src/app/modules/auth/auth.module').then(m => m.AuthModule)},
  {path: 'error', loadChildren: ()=>import('src/app/modules/error/error.module').then(m => m.ErrorModule)},
  {path: '**', redirectTo: 'error', pathMatch: 'full'}
]

/**const routes: Routes = [
  {
    path: '',
    redirectTo: environment.lang,
    pathMatch: 'full'
  },
  {
    path: 'welcome',
    redirectTo: `${environment.lang}/welcome`,
  },
  {
    path: 'user',
    redirectTo: `${environment.lang}/user`,
  },
  {
    path: 'checkout',
    redirectTo: `${environment.lang}/checkout`,
  },
  {
    path: 'auth',
    redirectTo: `${environment.lang}/auth`,
  },
  {
    path: 'error',
    redirectTo: `${environment.lang}/error`,
  },
  {
    path: 'fr',
    canActivate: [LangguardService],
    children: [
      { path: '', redirectTo: 'welcome', pathMatch: 'full' },
      {path: 'welcome', loadChildren: ()=>import('src/app/modules/welcome/welcome.module').then(m => m.WelcomeModule)},
      {path: 'user', loadChildren: ()=>import('src/app/modules/user/user.module').then(m => m.UserModule)},
      {path: 'checkout', loadChildren: ()=>import('src/app/modules/checkout/checkout.module').then(m => m.CheckoutModule)},
      {path: 'auth', loadChildren: ()=>import('src/app/modules/auth/auth.module').then(m => m.AuthModule)},
      {path: 'error', loadChildren: ()=>import('src/app/modules/error/error.module').then(m => m.ErrorModule)},
      {path: '**', redirectTo: 'error', pathMatch: 'full'}
    ]
  },
  {
    path: 'en',
    canActivate: [LangguardService],
    children: [
      { path: '', redirectTo: 'welcome', pathMatch: 'full' },
      {path: 'welcome', loadChildren: ()=>import('src/app/modules/welcome/welcome.module').then(m => m.WelcomeModule)},
      {path: 'user', loadChildren: ()=>import('src/app/modules/user/user.module').then(m => m.UserModule)},
      {path: 'checkout', loadChildren: ()=>import('src/app/modules/checkout/checkout.module').then(m => m.CheckoutModule)},
      {path: 'auth', loadChildren: ()=>import('src/app/modules/auth/auth.module').then(m => m.AuthModule)},
      {path: 'error', loadChildren: ()=>import('src/app/modules/error/error.module').then(m => m.ErrorModule)},
      {path: '**', redirectTo: 'error', pathMatch: 'full'}
    ]
  },
  {path: '**', redirectTo: environment.lang, pathMatch: 'full'},

];**/

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  providers: [{provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true}],
  exports: [RouterModule]
})
export class AppRoutingModule { }
